import React from 'react';
import createDataContext from './createDataContext';

export const reducer = (state, action) => {
  const {
    type,
    isWebBooker,
    step,
    code,
    pickup,
    dropoff,
    fare,
    accessibleVehicle,
    termsAndConditions,
    payment,
    inst,
    editor,
    tips,
    tipsValue,
    rideId,
    error,
    paymentMethodId,
    paymentListId,
    oneTimePaymentId,
    isRideStartedPopup,
    rideStatusRecordedFlags,
    country,
    accountCreation,
    downloadCurbAppUrl,
    serviceTypesAndAmounts,
    driverNote,
    defaultServiceType,
    previousStep,
    isCurbUserExist,
    userId,
    keepSignedIn,
    switchedBookingType,
    applePayPaymentMethod,
    payPalPaymentMethod,
    rideLater,
    fleets,
    selectedFleet,
    userProfile,
    initialRideEta,
    rideDetailsHistory,
    rideDetailsReceipt,
    defaultTips,
    userLocation,
    isUpcomingRidePopup,
    startingRideTime,
    customToken,
    deviceId,
    isMeteredFare,
    mixpanelEvents,
  } = action;
  switch (type) {
    case 'updateIsWebBooker':
      return { ...state, isWebBooker };
    case 'updateStep':
      return { ...state, step };
    case 'updateCode':
      return { ...state, code };
    case 'updatePickup':
      return { ...state, pickup };
    case 'updateDropoff':
      return { ...state, dropoff };
    case 'updateFare':
      return { ...state, fare };
    case 'updateVehicle':
      return { ...state, accessibleVehicle };
    case 'updateTermsAndConditions':
      return { ...state, termsAndConditions };
    case 'updatePayment':
      return { ...state, payment };
    case 'updateInst':
      return { ...state, inst };
    case 'updateRideId':
      return { ...state, rideId };
    case 'updateTips':
      return { ...state, tips };
    case 'updateTipsValue':
      return { ...state, tipsValue };
    case 'updateEditor':
      return { ...state, editor };
    case 'updateError':
      return { ...state, error };
    case 'updatePaymentMethodId':
      return { ...state, paymentMethodId };
    case 'updatePaymentListId':
      return { ...state, paymentListId };
    case 'updateOneTimePaymentId':
      return { ...state, oneTimePaymentId };
    case 'updateIsRideStartedPopup':
      return { ...state, isRideStartedPopup };
    case 'updateRideStatusRecordedFlags':
      return { ...state, rideStatusRecordedFlags };
    case 'updateCountry':
      return { ...state, country };
    case 'updateAccountCreation':
      return { ...state, accountCreation };
    case 'updateDownloadCurbAppUrl':
      return { ...state, downloadCurbAppUrl };
    case 'updateServiceTypesAndAmounts':
      return { ...state, serviceTypesAndAmounts };
    case 'updateDriverNote':
      return { ...state, driverNote };
    case 'updateDefaultServiceType':
      return { ...state, defaultServiceType };
    case 'updatePreviousStep':
      return { ...state, previousStep };
    case 'updateIsCurbUserExist':
      return { ...state, isCurbUserExist };
    case 'updateUserId':
      return { ...state, userId };
    case 'updateKeepSignedIn':
      return { ...state, keepSignedIn };
    case 'updateSwitchedBookingType':
      return { ...state, switchedBookingType };
    case 'updateApplePayPaymentMethod':
      return { ...state, applePayPaymentMethod };
    case 'updatePayPalPaymentMethod':
      return { ...state, payPalPaymentMethod };
    case 'updateRideLater':
      return { ...state, rideLater };
    case 'updateFleets':
      return { ...state, fleets };
    case 'updateSelectedFleet':
      return { ...state, selectedFleet };
    case 'updateUserProfile':
      return { ...state, userProfile };
    case 'updateInitialRideEta':
      return { ...state, initialRideEta };
    case 'clearBookerContext':
      return {};
    case 'updateRideDetailsHistory':
      return { ...state, rideDetailsHistory };
    case 'updateRideDetailsReceipt':
      return { ...state, rideDetailsReceipt };
    case 'updateDefaultTips':
      return { ...state, defaultTips };
    case 'updateUserLocation':
      return { ...state, userLocation };
    case 'updateIsUpcomingRidePopup':
      return { ...state, isUpcomingRidePopup };
    case 'updateStartingRideTime':
      return { ...state, startingRideTime };
    case 'updateCustomToken':
      return { ...state, customToken };
    case 'updateDeviceId':
      return { ...state, deviceId };
    case 'updateIsMeteredFare':
      return { ...state, isMeteredFare };
    case 'updateMixpanelEvents':
      return { ...state, mixpanelEvents };
    default:
      return { ...state };
  }
};

const updateIsWebBooker = dispatch => isWebBooker => {
  dispatch({ type: 'updateIsWebBooker', isWebBooker });
};
const updateStep = dispatch => step => {
  dispatch({ type: 'updateStep', step });
};
const updateCode = dispatch => code => {
  dispatch({ type: 'updateCode', code });
};
const updatePickup = dispatch => pickup => {
  dispatch({ type: 'updatePickup', pickup });
};
const updateDropoff = dispatch => dropoff => {
  dispatch({ type: 'updateDropoff', dropoff });
};
const updateFare = dispatch => fare => {
  dispatch({ type: 'updateFare', fare });
};
const updateVehicle = dispatch => accessibleVehicle => {
  dispatch({ type: 'updateVehicle', accessibleVehicle });
};
const updateTermsAndConditions = dispatch => termsAndConditions => {
  dispatch({ type: 'updateTermsAndConditions', termsAndConditions });
};
const updatePayment = dispatch => payment => {
  dispatch({ type: 'updatePayment', payment });
};
const updateInst = dispatch => inst => {
  dispatch({ type: 'updateInst', inst });
};
const updateRideId = dispatch => rideId => {
  dispatch({ type: 'updateRideId', rideId });
};
const updateTips = dispatch => tips => {
  dispatch({ type: 'updateTips', tips });
};
const updateTipsValue = dispatch => tipsValue => {
  dispatch({ type: 'updateTipsValue', tipsValue });
};
const updateEditor = dispatch => editor => {
  dispatch({ type: 'updateEditor', editor });
};
const updateError = dispatch => error => {
  dispatch({ type: 'updateError', error });
};
const updatePaymentMethodId = dispatch => paymentMethodId => {
  dispatch({ type: 'updatePaymentMethodId', paymentMethodId });
};
const updatePaymentListId = dispatch => paymentListId => {
  dispatch({ type: 'updatePaymentListId', paymentListId });
};
const updateOneTimePaymentId = dispatch => oneTimePaymentId => {
  dispatch({ type: 'updateOneTimePaymentId', oneTimePaymentId });
};
const updateIsRideStartedPopup = dispatch => isRideStartedPopup => {
  dispatch({ type: 'updateIsRideStartedPopup', isRideStartedPopup });
};
const updateRideStatusRecordedFlags = dispatch => rideStatusRecordedFlags => {
  dispatch({ type: 'updateRideStatusRecordedFlags', rideStatusRecordedFlags });
};
const updateCountry = dispatch => country => {
  dispatch({ type: 'updateCountry', country });
};
const updateAccountCreation = dispatch => accountCreation => {
  dispatch({ type: 'updateAccountCreation', accountCreation });
};
const updateDownloadCurbAppUrl = dispatch => downloadCurbAppUrl => {
  dispatch({ type: 'updateDownloadCurbAppUrl', downloadCurbAppUrl });
};
const updateServiceTypesAndAmounts = dispatch => serviceTypesAndAmounts => {
  dispatch({ type: 'updateServiceTypesAndAmounts', serviceTypesAndAmounts });
};
const updateDriverNote = dispatch => driverNote => {
  dispatch({ type: 'updateDriverNote', driverNote });
};
const updateDefaultServiceType = dispatch => defaultServiceType => {
  dispatch({ type: 'updateDefaultServiceType', defaultServiceType });
};
const updatePreviousStep = dispatch => previousStep => {
  dispatch({ type: 'updatePreviousStep', previousStep });
};
const updateIsCurbUserExist = dispatch => isCurbUserExist => {
  dispatch({ type: 'updateIsCurbUserExist', isCurbUserExist });
};
const updateUserId = dispatch => userId => {
  dispatch({ type: 'updateUserId', userId });
};
const updateKeepSignedIn = dispatch => keepSignedIn => {
  dispatch({ type: 'updateKeepSignedIn', keepSignedIn });
};
const updateSwitchedBookingType = dispatch => switchedBookingType => {
  dispatch({ type: 'updateSwitchedBookingType', switchedBookingType });
};
const updateApplePayPaymentMethod = dispatch => applePayPaymentMethod => {
  dispatch({ type: 'updateApplePayPaymentMethod', applePayPaymentMethod });
};
const updatePayPalPaymentMethod = dispatch => payPalPaymentMethod => {
  dispatch({ type: 'updatePayPalPaymentMethod', payPalPaymentMethod });
};
const updateRideLater = dispatch => rideLater => {
  dispatch({ type: 'updateRideLater', rideLater });
};
const updateFleets = dispatch => fleets => {
  dispatch({ type: 'updateFleets', fleets });
};
const updateSelectedFleet = dispatch => selectedFleet => {
  dispatch({ type: 'updateSelectedFleet', selectedFleet });
};
const updateUserProfile = dispatch => userProfile => {
  dispatch({ type: 'updateUserProfile', userProfile });
};
const updateInitialRideEta = dispatch => initialRideEta => {
  dispatch({ type: 'updateInitialRideEta', initialRideEta });
};
const clearBookerContext = dispatch => () => {
  dispatch({ type: 'clearBookerContext' });
};
const updateUserLocation = dispatch => userLocation => {
  dispatch({ type: 'updateUserLocation', userLocation });
};
const updateRideDetailsHistory = dispatch => rideDetailsHistory => {
  dispatch({ type: 'updateRideDetailsHistory', rideDetailsHistory });
};
const updateRideDetailsReceipt = dispatch => rideDetailsReceipt => {
  dispatch({ type: 'updateRideDetailsReceipt', rideDetailsReceipt });
};
const updateDefaultTips = dispatch => defaultTips => {
  dispatch({ type: 'updateDefaultTips', defaultTips });
};
const updateIsUpcomingRidePopup = dispatch => isUpcomingRidePopup => {
  dispatch({ type: 'updateIsUpcomingRidePopup', isUpcomingRidePopup });
};
const updateStartingRideTime = dispatch => startingRideTime => {
  dispatch({ type: 'updateStartingRideTime', startingRideTime });
};
const updateCustomToken = dispatch => customToken => {
  dispatch({ type: 'updateCustomToken', customToken });
};
const updateDeviceId = dispatch => deviceId => {
  dispatch({ type: 'updateDeviceId', deviceId });
};
const updateIsMeteredFare = dispatch => isMeteredFare => {
  dispatch({ type: 'updateIsMeteredFare', isMeteredFare });
};
const updateMixpanelEvents = dispatch => mixpanelEvents => {
  dispatch({ type: 'updateMixpanelEvents', mixpanelEvents });
};

const boundActions = {
  updateIsWebBooker,
  updateStep,
  updateCode,
  updatePickup,
  updateDropoff,
  updateFare,
  updatePayment,
  updateVehicle,
  updateTermsAndConditions,
  updateInst,
  updateRideId,
  updateTips,
  updateTipsValue,
  updateEditor,
  updateError,
  updatePaymentMethodId,
  updatePaymentListId,
  updateOneTimePaymentId,
  updateIsRideStartedPopup,
  updateRideStatusRecordedFlags,
  updateCountry,
  updateAccountCreation,
  updateDownloadCurbAppUrl,
  updateServiceTypesAndAmounts,
  updateDriverNote,
  updateDefaultServiceType,
  updatePreviousStep,
  updateIsCurbUserExist,
  updateUserId,
  updateKeepSignedIn,
  updateSwitchedBookingType,
  updateApplePayPaymentMethod,
  updatePayPalPaymentMethod,
  updateRideLater,
  updateFleets,
  updateSelectedFleet,
  updateUserProfile,
  updateInitialRideEta,
  clearBookerContext,
  updateRideDetailsHistory,
  updateRideDetailsReceipt,
  updateDefaultTips,
  updateUserLocation,
  updateIsUpcomingRidePopup,
  updateStartingRideTime,
  updateCustomToken,
  updateDeviceId,
  updateIsMeteredFare,
  updateMixpanelEvents,
};

export const initialState = {
  isWebBooker: false,
  step: 0,
  code: '',
  pickup: '',
  dropoff: '',
  fare: '',
  accessibleVehicle: { value: false, required: false },
  payment: '',
  termsAndConditions: { value: false, required: true },
  keepSignedIn: { value: false, required: false },
  inst: '',
  editor: '',
  tips: '',
  tipsValue: '',
  rideId: '',
  error: '',
  paymentMethodId: '',
  paymentListId: '',
  oneTimePaymentId: null,
  isRideStartedPopup: '',
  rideStatusRecordedFlags: {
    isRideAssignRecorded: false,
    isRideCompleteRecorded: false,
  },
  country: '',
  accountCreation: '',
  downloadCurbAppUrl: '',
  serviceTypesAndAmounts: {},
  driverNote: '',
  defaultServiceType: 'taxi',
  previousStep: '',
  isCurbUserExist: false,
  userId: '',
  switchedBookingType: { isSwitched: false, type: '' },
  fleets: null,
  selectedFleet: null,
  userProfile: null,
  initialRideEta: null,
  applePayPaymentMethod: '',
  payPalPaymentMethod: '',
  rideDetailsHistory: null,
  rideDetailsReceipt: null,
  defaultTips: {},
  userLocation: {},
  rideLater: {},
  isUpcomingRidePopup: false,
  startingRideTime: null,
  customToken: false,
  deviceId: null,
  isMeteredFare: false,
  mixpanelEvents: {},
};

const { Context: BookerContext, Provider: BookerProvider } = createDataContext(reducer, boundActions, initialState);

export { BookerProvider };
export default BookerContext;
